<template>
  <DefaultLayout>
    <div slot="content">
      <!-- FEATURE LIMITED DIALOG-->
      <v-dialog v-model="featureLimitedModal" width="400" persistent>
        <v-card>
          <v-card-title>Feature limited</v-card-title>
          <v-card-text>{{ featureLimitedText || featureLimitedDefaultText }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="featureLimitedModal = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END FEATURE LIMITED DIALOG-->

      <!-- REQUEST BASIC DATA REPORT DIALOG-->
      <v-dialog v-model="basicDataModel" persistent max-width="700">
        <v-card>
          <v-card-title>Generate profiles basic data report</v-card-title>
          <v-card-text>
            <p class="font-weight-light body-2">
              Creating the profiles basic data export can take some time. When this report is
              finished, we will send you an email with a download link for this report. Note that
              this report will contain only profiles between date range set on this page and the
              link to the report will be purged after 1h.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              tile
              text
              color="blue"
              :disabled="basicDataLoading"
              @click="basicDataModel = false"
              >Cancel</v-btn
            >
            <v-btn
              tile
              depressed
              dark
              color="blue"
              :loading="basicDataLoading"
              @click="exportBasicData"
              >Create report</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- EMD REQUEST BASIC DATA REPORT DIALOG-->

      <div class="d-flex align-center mb-3">
        <div class="title">Reporting and data export</div>
        <v-spacer></v-spacer>
        <v-btn tile outlined small color="blue" @click="basicDataModel = true">
          <v-icon small left dark>fas fa-paper-plane</v-icon>
          Generate profiles basic data report
        </v-btn>
        <v-btn class="ml-3" tile outlined small color="blue" @click="exportActivity">
          <v-icon small left dark>fal fa-file-download</v-icon>
          Export activity report
        </v-btn>
      </div>
      <v-divider></v-divider>
      <!-- FILTERS -->
      <v-row class="mt-1 mb-5">
        <v-col style="min-width: 120px" class="py-0">
          <v-menu
            ref="fromDateMenu"
            :close-on-content-click="false"
            v-model="fromDateMenu"
            :return-value.sync="fromDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                label="From"
                v-model="computedFromDate"
                readonly
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="fromDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn tile small text @click="fromDateMenu = false">Cancel</v-btn>
              <v-btn tile small dark depressed color="blue" @click="updateFromDate(fromDate)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col style="min-width: 120px" class="py-0">
          <v-menu
            ref="toDateMenu"
            :close-on-content-click="false"
            v-model="toDateMenu"
            :return-value.sync="toDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                label="To"
                v-model="computedToDate"
                readonly
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="toDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn tile small text @click="toDateMenu = false">Cancel</v-btn>
              <v-btn tile small dark depressed color="blue" @click="updateToDate(toDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0">
          <v-checkbox :disabled="!pendingCount" v-model="rModel.pending" color="gray" hide-details>
            <template v-slot:label>
              <div class="whitespace-nowrap grey--text text--darken-3 body-2">
                Pending ({{ pendingCount }})
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col class="py-0">
          <v-checkbox
            :disabled="!completedCount"
            v-model="rModel.completed"
            color="gray"
            hide-details
          >
            <template v-slot:label>
              <div class="whitespace-nowrap grey--text text--darken-3 body-2">
                Completed ({{ completedCount }})
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col class="py-0">
          <v-checkbox
            :disabled="!archivedCount"
            v-model="rModel.archived"
            color="gray"
            hide-details
          >
            <template v-slot:label>
              <div class="whitespace-nowrap grey--text text--darken-3 body-2">
                Archived ({{ archivedCount }})
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col class="py-0">
          <v-checkbox :disabled="!purgeCount" v-model="rModel.purge" color="gray" hide-details>
            <template v-slot:label>
              <div class="whitespace-nowrap grey--text text--darken-3 body-2">
                Purge ({{ purgeCount }})
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col class="py-0">
          <v-checkbox :disabled="!purgedCount" v-model="rModel.purged" color="gray" hide-details>
            <template v-slot:label>
              <div class="whitespace-nowrap grey--text text--darken-3 body-2">
                Purged ({{ purgedCount }})
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col class="py-0">
          <v-checkbox
            :disabled="!canceledCount"
            v-model="rModel.canceled"
            color="gray"
            hide-details
          >
            <template v-slot:label>
              <div class="whitespace-nowrap grey--text text--darken-3 body-2">
                Cancelled ({{ canceledCount }})
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <!-- END FILTERS -->
      <div v-if="preparedRequests && preparedRequests.length && !loading" style="height: 200px">
        <ECharts :options="chartOptions" autoresize />
      </div>
      <div
        v-if="preparedRequests && preparedRequests.length && !loading"
        class="d-flex align-center py-3"
      >
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          hide-details
          dense
        ></v-text-field>
      </div>
      <v-data-table
        v-if="preparedRequests && preparedRequests.length && !loading"
        :headers="headers"
        :items="preparedRequests"
        item-key="id"
        class="no-hover-row"
        :search="search"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
          showFirstLastPage: false,
          prevIcon: 'fal fa-chevron-left',
          nextIcon: 'fal fa-chevron-right',
          itemsPerPageText: 'Requests per page'
        }"
        :hide-default-footer="preparedRequests.length < 11"
      >
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            :pagination="pagination"
            :options="options"
            :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
            :showFirstLastPage="false"
            prevIcon="fal fa-chevron-left"
            nextIcon="fal fa-chevron-right"
            @update:options="updateOptions"
            items-per-page-text="Requests per page"
          />
        </template>
        <template v-slot:item.status="{ item }">
          <v-tooltip top v-if="item.status === 1">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="teal">fal fa-watch</v-icon>
            </template>
            <span>Pending</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 2">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="red">fal fa-times</v-icon>
            </template>
            <span>Canceled</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 3">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="blue">fal fa-check</v-icon>
            </template>
            <span>Completed</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 4">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="red">fal fa-hand-rock</v-icon>
            </template>
            <span>Revoked</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 5">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="red">fal fa-user-times</v-icon>
            </template>
            <span>Deleted</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 6">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="blue">fal fa-cabinet-filing</v-icon>
            </template>
            <span>Archived</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 7">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="red">fal fa-shredder</v-icon>
            </template>
            <span>Purge</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 8">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="red">fal fa-shredder</v-icon>
            </template>
            <span>Purged</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 9">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="red">fal fa-hand-paper</v-icon>
            </template>
            <span>Rejected</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 10">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="blue">fal fa-thumbs-up</v-icon>
            </template>
            <span>Accepted</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 11">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="red">fal fa-calendar-times</v-icon>
            </template>
            <span>Expired</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status === 12">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" left small color="blue">fal fa-shredder</v-icon>
            </template>
            <span>Purge Requested</span>
          </v-tooltip>
        </template>
        <template v-slot:item.dateCreated="{ item }">{{ getDate(item.dateCreated) }}</template>
      </v-data-table>
      <div v-if="loading" class="text-center pt-12 mt-12 headline">
        <v-progress-circular
          indeterminate
          color="blue-grey"
          width="2"
          size="50"
        ></v-progress-circular>
      </div>
      <div
        v-if="!preparedRequests.length && !loading"
        class="text-center pt-12 mt-12 headline font-weight-bold grey--text"
      >
        No requests match the currently applied filters
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import { mapState } from 'vuex';
import {
  CHECK_ORGANIZATIONS,
  GET_ACTIVITY_REPORT_RECORDS,
  GENERATE_BASIC_DATA_REPORT
} from '@/store/actions.type';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import DefaultLayout from '@/layouts/DefaultLayout';

export default {
  name: 'reports',
  components: {
    DefaultLayout,
    ECharts
  },
  data() {
    return {
      search: '',
      featureLimitedModal: false,
      featureLimitedText: '',
      featureLimitedDefaultText: 'To enable this feature, you need to upgrade your price plan.',
      privacyEmail: '',
      fromDateMenu: false,
      fromDate: null,
      toDateMenu: false,
      toDate: null,
      rModel: {
        pending: true,
        completed: true,
        archived: true,
        purge: true,
        purged: true,
        canceled: true
      },
      requests: [],
      filteredRequests: [],
      headers: [
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'Created', value: 'dateCreated', align: 'left' },
        { text: 'Template', value: 'templateName', align: 'left' },
        { text: 'Requester', value: 'userName', align: 'left' },
        { text: 'Reference', value: 'reference', align: 'left' },
        { text: 'Client', value: 'clientName', align: 'left' }
      ],
      pagination: {
        sortBy: 'created'
      },
      users: [],
      chartOptions: {},
      loading: true,
      basicDataModel: false,
      basicDataLoading: false
    };
  },
  watch: {
    rModel: {
      handler: function () {
        this.filterRequests();
      },
      deep: true
    },
    featureLimitedModal(val) {
      if (!val) {
        this.featureLimitedText = '';
      }
    }
  },
  computed: {
    ...mapState({ organization: (state) => state.organizations.userSelectedOrganization }),
    ...mapState({ signedInUser: (state) => state.auth.account }),
    ...mapState({
      limitations: (state) => state.organizations.userSelectedOrganization.limitations
    }),
    pendingCount() {
      return this.requests.filter((x) => x.status === 1).length;
    },
    completedCount() {
      return this.requests.filter((x) => x.status === 3).length;
    },
    archivedCount() {
      return this.requests.filter((x) => x.status === 6).length;
    },
    purgeCount() {
      return this.requests.filter((x) => x.status === 7).length;
    },
    purgedCount() {
      return this.requests.filter((x) => x.status === 8).length;
    },
    canceledCount() {
      return this.requests.filter((x) => x.status === 2).length;
    },
    computedFromDate() {
      return this.formatDate(this.fromDate);
    },
    computedToDate() {
      return this.formatDate(this.toDate);
    },
    updatedToDate() {
      const nextToDate = new Date(this.toDate);
      nextToDate.setDate(nextToDate.getDate() + 1);
      let dd = '' + nextToDate.getDate();
      let mm = '' + (nextToDate.getMonth() + 1);
      const yyyy = nextToDate.getFullYear();
      mm = mm.length < 2 ? '0' + mm : mm;
      dd = dd.length < 2 ? '0' + dd : dd;
      return [yyyy, mm, dd].join('-');
    },
    preparedRequests() {
      const requestsList = [];
      this.filteredRequests.forEach((request) => {
        const requestItem = {
          status: request.status,
          dateCreated: request.dateCreated,
          userName: `${request.requesterFirstName} ${request.requesterLastName}`,
          reference: request.references
            .map(function (rf) {
              return rf.value;
            })
            .join(', '),
          clientName: `${request.requestedFirstName} ${request.requestedLastName}`,
          templateName: request.templateName
        };
        requestsList.push(requestItem);
      });

      return requestsList;
    }
  },
  methods: {
    formatDate(date) {
      // format date from 2019-09-18 to 18/09/2019
      if (!date) return null;
      const splitDate = date.split('-');
      return `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async fetchRequests() {
      this.loading = true;
      const data = {
        accountId: this.organization.id,
        from: this.fromDate,
        to: this.updatedToDate
      };

      try {
        const response = await this.$store.dispatch(GET_ACTIVITY_REPORT_RECORDS, data);
        response.profiles.forEach((request) => {
          request.dateCreated = new Date(request.dateCreated);
          request.dateCreatedISO = request.dateCreated.toISOString().split('T')[0];
          var temp = response.templates.find((el) => el.id === request.templateId);
          if (temp) {
            request.templateName = temp.name;
          } else {
            request.templateName = 'UNKNOWN';
          }
        });
        this.requests = response.profiles;
        this.filterRequests();
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error getting organization requests. Please contact support@planetverify.com'
        });
      }
      const users = [];
      this.organization.accounts.forEach((account) => {
        if (account.users && account.users.length > 0) {
          account.users.forEach((user) => {
            users.push({
              id: user.id,
              name: `${user.firstName} ${user.lastName}`
            });
          });
        }
      });
      this.users = users;
    },
    filterRequests() {
      this.filteredRequests = this.requests;
      if (!this.rModel.pending) {
        this.filteredRequests = this.filteredRequests.filter((x) => x.status !== 1);
      }
      if (!this.rModel.completed) {
        this.filteredRequests = this.filteredRequests.filter((x) => x.status !== 3);
      }
      if (!this.rModel.archived) {
        this.filteredRequests = this.filteredRequests.filter((x) => x.status !== 6);
      }
      if (!this.rModel.purge) {
        this.filteredRequests = this.filteredRequests.filter((x) => x.status !== 7);
      }
      if (!this.rModel.purged) {
        this.filteredRequests = this.filteredRequests.filter((x) => x.status !== 8);
      }
      if (!this.rModel.canceled) {
        this.filteredRequests = this.filteredRequests.filter((x) => x.status !== 2);
      }
      this.updateChart();
    },
    updateChart() {
      const ech = [['Date', 'Pending', 'Completed', 'Archived', 'Purge', 'Purged', 'Canceled']];
      const dates = this.getDates(new Date(this.fromDate), new Date(this.updatedToDate));
      dates.forEach((dd) => {
        const dateReq = this.filteredRequests.filter((x) => x.dateCreatedISO === dd);
        if (!dateReq.length) {
          ech.push([dd, 0, 0, 0, 0, 0, 0]);
          return;
        }
        ech.push([
          dd,
          dateReq.filter((x) => x.status == 1).length,
          dateReq.filter((x) => x.status == 3).length,
          dateReq.filter((x) => x.status == 6).length,
          dateReq.filter((x) => x.status == 7).length,
          dateReq.filter((x) => x.status == 8).length,
          dateReq.filter((x) => x.status == 2).length
        ]);
      });
      const polar = {
        color: ['#F4B942', '#97D8C4', '#7D4600', '#F58F29', '#A4B0F5', '#B74F6F'],
        dataset: {
          source: ech
        },
        xAxis: {
          type: 'category',
          splitLine: { show: true, lineStyle: { type: 'dashed' } },
          axisLine: { lineStyle: { color: '#BDBDBD' } },
          axisLabel: { color: '#BDBDBD' }
        },
        yAxis: {
          type: 'value',
          splitLine: { show: true, lineStyle: { type: 'dashed' } },
          axisLine: { lineStyle: { color: '#BDBDBD' } },
          axisLabel: { color: '#BDBDBD' }
        },
        series: [
          { type: 'bar', stack: 'ccc' },
          { type: 'bar', stack: 'ccc' },
          { type: 'bar', stack: 'ccc' },
          { type: 'bar', stack: 'ccc' },
          { type: 'bar', stack: 'ccc' },
          { type: 'bar', stack: 'ccc' }
        ],
        grid: {
          top: '5%',
          left: '1%',
          right: '1%',
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        }
      };
      this.chartOptions = polar;
    },
    getDates(startDate, endDate) {
      const dates = [];
      let currentDate = startDate;
      const addDays = function (days) {
        const date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      while (currentDate <= endDate) {
        dates.push(currentDate.toISOString().split('T')[0]);
        currentDate = addDays.call(currentDate, 1);
      }
      return dates;
    },
    getDate(dateTime) {
      const formattedDate = new Date(dateTime).toLocaleString('en-GB', { timeZone: 'UTC' });
      return formattedDate;
    },
    updateFromDate(date) {
      this.$refs.fromDateMenu.save(date);
      this.fetchRequests();
    },
    updateToDate(date) {
      this.$refs.toDateMenu.save(date);
      this.fetchRequests();
    },
    exportActivity() {
      const rows = [];

      rows.push(`ReportDateFrom, ${this.fromDate}, ReportDateTo, ${this.toDate}`);
      rows.push(`TotalRequests, ${this.filteredRequests.length}`);
      rows.push(
        `OpenRequests, ${
          this.filteredRequests.filter((x) => x.status === 1 || x.status === 3).length
        }`
      );
      rows.push(
        `OpenCompletedRequests, ${this.filteredRequests.filter((x) => x.status === 3).length}`
      );
      rows.push(
        `OpenRejected, ${
          this.filteredRequests.filter((x) => this.getActivityProfileStatus(x) === 'Open-rejected')
            .length
        }`
      );
      rows.push(
        `ClosedApproved, ${
          this.filteredRequests.filter((x) => x.outcome && x.outcome === 1).length
        }`
      );
      rows.push(
        `ClosedDeclined, ${
          this.filteredRequests.filter((x) => x.outcome && x.outcome === 2).length
        }`
      );

      rows.push('');

      rows.push('Id, Reference, DateCreated, DateUpdated, Status, Outcome');
      this.filteredRequests.forEach((request) => {
        rows.push(
          `"${request.id}","${this.getReferences(request.references)}","${this.getDate(
            request.dateCreated
          )}","${this.getDate(request.dateUpdated)}",${this.getStatus(
            request.status
          )},${this.getActivityProfileStatus(request)}`
        );
      });

      this.saveCSV('activity_report', rows);
    },
    getReferences(references) {
      var refs = [];
      references.forEach((el) => {
        refs.push(el.value);
      });
      return refs.join(', ');
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return 'Pending';
        case 2:
          return 'Cancelled';
        case 3:
          return 'Completed';
        case 4:
          return 'Revoked';
        case 5:
          return 'Deleted';
        case 6:
          return 'Archived';
        case 7:
          return 'Purge';
        case 8:
          return 'Purged';
        case 9:
          return 'Rejected';
        case 10:
          return 'Accepted';
        case 11:
          return 'Expired';
        case 12:
          return 'PurgeRequested';
        default:
          return '';
      }
    },
    getActivityProfileStatus(request) {
      if (!request || !Array.isArray(request.notes)) {
        return 'Open';
      }

      if (request.outcomeString) {
        return request.outcomeString;
      }

      if (request.notes.length > 0) {
        request.notes.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

        const latestNote = request.notes[0].note;
        const isRejected = latestNote && latestNote.endsWith('rejected');
        return isRejected ? 'Open-rejected' : 'Open';
      }

      return 'Open';
    },

    async exportBasicData() {
      this.basicDataLoading = true;
      const data = {
        accountId: this.organization.id,
        from: this.fromDate,
        to: this.updatedToDate,
        includePending: this.rModel.pending,
        includeCompleted: this.rModel.completed,
        includeArchived: this.rModel.archived,
        includePurge: this.rModel.purge,
        includePurged: this.rModel.purged,
        includeCancelled: this.rModel.canceled
      };
      try {
        const response = await this.$store.dispatch(GENERATE_BASIC_DATA_REPORT, data);
        this.basicDataLoading = false;
        this.basicDataModel = false;
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Profiles basic data report requested'
        });
      } catch (err) {
        this.basicDataLoading = false;
        this.basicDataModel = false;
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error creating basic data report. Please contact support@planetverify.com'
        });
      }
    },
    saveCSV(name, rowsArray) {
      if (!name) {
        name = 'output.csv';
      } else {
        name += '.csv';
      }
      let csvContent = '';
      rowsArray.forEach((row) => {
        csvContent += row + '\r\n';
      });
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const link = document.body.appendChild(document.createElement('a'));

      if (navigator.msSaveOrOpenBlob) {
        // Works for Internet Explorer and Microsoft Edge
        navigator.msSaveOrOpenBlob(blob, name);
      } else if ('download' in link) {
        // Attempt to use an alternative method
        link.href = URL.createObjectURL(blob);
        link.download = name;
        link.click();
      } else {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: "Your browser doesn't allow to export csv files. "
        });
      }
    }
  },
  async mounted() {
    await this.$store.dispatch(CHECK_ORGANIZATIONS);
    let now = new Date();
    this.toDate = new Date(now.toString().split('GMT')[0] + ' UTC').toISOString().split('T')[0];
    now.setDate(now.getDate() - 14);
    this.fromDate = new Date(now.toString().split('GMT')[0] + ' UTC').toISOString().split('T')[0];
    await this.fetchRequests();
    this.filteredRequests = this.requests;
  }
};
</script>

<style>
.echarts {
  width: 100%;
  height: 100%;
}
.v-data-table.no-hover-row tr:hover {
  background: none !important;
}
</style>
